import React from "react";

class FlexHorizontal extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children, ...rest } = this.props;
        return (
            <div className="flex_horrizontal" {...rest}>
                {children}
            </div>
        );
    }
}

class FlexSpacer extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children, ...rest } = this.props;
        return (
            <div className="flex_spacer" {...rest}>
                {children}
            </div>
        );
    }
}

export { FlexHorizontal, FlexSpacer };
